<template>
    <el-drawer
            v-model="drawers"
            direction="rtl"
            :size="size"
    >
        <span>
            <p>{{title}}</p>
            <el-row class="demo-autocomplete">
              <el-col :span="12">
                <el-autocomplete
                        class="inline-input"
                        v-model.trim="state1"
                        :fetch-suggestions="querySearch"
                        placeholder=""
                        :trigger-on-focus="true"
                        @select="handleSelect"
                ></el-autocomplete>
              </el-col>

            </el-row>
        </span>
        <div>

            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="value"
                        :label="name"
                >
                </el-table-column>
                <el-table-column
                        prop="mate"
                        :label="mate"
                >
                </el-table-column>
                <el-table-column
                        prop="num"
                        :label="nums"
                >
                </el-table-column>
            </el-table>

        </div>
        <div>
            <el-row>
                <el-col :span="24" style="text-align: center">
                    <el-pagination
                            :page-size="10"
                            layout="prev, pager, next"
                            :default-current-page=currentPage
                            @current-change="currentPages"
                            :current-page=currentPage
                            :total=total
                    >
                    </el-pagination>
                </el-col>
            </el-row>
        </div>
    </el-drawer>
</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "AboutDrawer",

        data(){
            return{
                drawers: false,
                tableData: [],
                total:100,
                restaurants: [],
                state1: '',
                currentPage:1,
                title:"",
                mate:"",
                name:"",
                nums:'',
                size:"50%",

            }
        },
        methods: {
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            loadAll(data) {
                let arr=[];
                for (let i = 0; i <data.length ; i++) {
                    arr.push(data[i])
                }
                return arr;
            },
            handleSelect(item) {

                this.getData(1)
            },
            currentPages(val){
                this.currentPage=val
                this.getData(val)
            },
            getData(currentPage){
                let url=this.state1==""?"/online/"+currentPage:"/online/"+currentPage+"/"+this.state1
                request.get(url).then(res =>{

                    this.tableData=res.data.tableData;
                    this.total=res.data.total;
                    for (let i = 0; i <this.tableData.length ; i++) {
                        this.tableData[i].num=this.tableData[i].num.split(".")[0]
                    }

                }).catch((res)=>{
                })
            },
            firstload(){
                request.get("/online/1").then(res =>{
                    this.tableData=res.data.tableData;
                    this.restaurants = this.loadAll(res.data.allTypes);
                    this.total=res.data.total;
                    this.currentPage=res.data.currentPage;
                    for (let i = 0; i <this.tableData.length ; i++) {
                        this.tableData[i].num=this.tableData[i].num.split(".")[0]
                    }
                }).catch((res)=>{
                })
            },
            changeDrawer(data,title,name,mate,nums,pc){
                this.drawers=data;
                this.title=title;
                this.mate=mate;
                this.name=name;
                this.nums=nums;
                this.firstload();
                if (pc){
                    this.size="50%"
                }else {
                    this.size="100%"
                }
            }
        },


    }
</script>
